import { render } from "./JoinGameDialog.vue?vue&type=template&id=f916e77e"
import script from "./JoinGameDialog.vue?vue&type=script&lang=js"
export * from "./JoinGameDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__